import * as React from 'react'

import {
  SitterMobileMonthlyReserveListItem as SitterMobileMonthlyReserveListItemPresenter,
  IProps,
} from './presenter'
import { getMonthlyReserve } from '@/apis/reserves'

export const SitterMobileMonthlyReserveListItem = (
  props: Omit<IProps, 'clickhandler'>,
): JSX.Element => {
  const [reserves, setReserves] = React.useState(props.reserves)
  const [isActive, toggleAcitve] = React.useState(props.isActive)
  const handleClick = async (year: number, month: number) => {
    const result = await getMonthlyReserve(year, month)

    if (result.result) {
      setReserves(result.res)
      toggleAcitve(!isActive)
    }
  }

  return (
    <SitterMobileMonthlyReserveListItemPresenter
      reserves={reserves}
      year={props.year}
      month={props.month}
      isActive={isActive}
      clickhandler={handleClick}
    />
  )
}

export default SitterMobileMonthlyReserveListItem
